<template>
    <form @submit.prevent="handleSubmit">
        <div v-for="lob, index in currentLobs" :key="`lobz${index}`">
            <label class="fw-bold">{{ lob.line_of_business }}</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">Gross Sales:</span>
                </div>
                <input :id="`grossinput${index}`" v-show="isFocused" @blur="handleBlur(index)"
                    class="form-control text-end" type="number" step="0.1" :min="lob.origCapitalization * 1.2"
                    v-model="lob.capitalization" />
                <input :id="`grosstext${index}`" v-show="!isFocused" @focus="handleFocus(index)"
                    class="form-control text-end" type="text" :value="Formatters.formatCurrency(lob.capitalization)" />

            </div>
        </div>
        <SaveCancel class="mt-2" @cancel="close" />
    </form>
</template>

<script setup>
import { nextTick, ref, watch } from 'vue';
import SaveCancel from '../commons/SaveCancel.vue';
import confirmationService from '@/services/confirmationService';
import Formatters from '@/utils/formatters';
// eslint-disable-next-line
const props = defineProps({
    lobs: {
        type: Array(),
        default: () => []
    }
});

// eslint-disable-next-line 
const emit = defineEmits(['close', 'save']);


const isFocused = ref(false);

const handleBlur = () => {
    isFocused.value = false;
}
const handleFocus = (index) => {
    isFocused.value = true;
    nextTick(() => {
        const element = document.getElementById(`grossinput${index}`);
        if (element) {
            element.focus();
        }
    })
}

const handleSubmit = async () => {

    const confirmed = await confirmationService.show("Are you sure you want to proceed?");
    if (!confirmed) return;
    emit('save', currentLobs.value);
}


const currentLobs = ref([]);

const close = () => {
    emit('close')
}
const focus = () => {
    const element = document.getElementById('grosstext0');
    if (element) {
        element.focus();
        element.select();
    }
}
// eslint-disable-next-line 
defineExpose({ focus })


watch(() => props.lobs, (newVal) => {
    if (newVal) {
        currentLobs.value = newVal.map(item => ({
            ...item,
            origCapitalization: item.capitalization || 0,
            capitalization: item.capitalization * 1.2

        }));
    } else {
        currentLobs.value = [];
    }
}, { immediate: true, deep: true });

</script>